// Salasanalomakkeen tarkistus: kirjoitusvirhe uuden salasanan asetuksessa lukitsisi tilin, joten luonnissa ja
// palautuksessa salasana annetaan kahdesti. Kirjautumisessa vahvistusta ei kysytä (väärä salasana tulee palvelimelta).

export const MIN_PASSWORD = 10;

/**
 * Palauttaa käyttäjälle näytettävän virheen tai null, kun salasanat kelpaavat.
 * mode: "login" | "register" | "recover".
 */
export function passwordProblem(password, confirm, mode) {
  if (mode === "login") return null;
  if (password.length < MIN_PASSWORD) return `Salasanassa pitää olla vähintään ${MIN_PASSWORD} merkkiä.`;
  if (password !== confirm) return "Salasanat eivät ole samat. Tarkista kirjoitusvirheet.";
  return null;
}

/** Lyhyt vihje kentän alle kirjoittamisen aikana: tyhjänä ei näytetä mitään, ettei se huuda ennen aikojaan. */
export function matchHint(password, confirm) {
  if (!confirm) return "";
  return password === confirm ? "Salasanat täsmäävät." : "Salasanat eivät vielä täsmää.";
}
